// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"865eb04d","2393":"865eb04d"}[chunkId] + ".chunk.css";
};